import { createFiltersModel } from '@/pages/common/filters/create-filters-model'
import { createPageParamsModel } from '@/pages/common/page-params/create-page-params-model'

export const FAQFilters = createFiltersModel({
  search_area: 'search_all',
})

export const FAQPageParams = createPageParamsModel()
